import React from 'react'

import { VideoDetails } from 'common/client-data-types/VideoDetails'
import {
    StyledTitleOverlay,
    StyledInset,
    StyledTitles,
    StyledHeading,
    StyledVideoMetadata,
    StyledAutoplayWrap,
    StyledCountdown,
    StyledCountdownTime,
    StyledCancel,
} from 'component-library/content/Video/components/TitleOverlay/TitleOverlay.styled'

import { PlayButton } from 'component-library/buttons/PlayButton/PlayButton'
import { Product } from 'component-library/__product'
import { ThemedRender } from 'component-library/__styling/themed-render'
import { useProduct } from 'common/hooks/useProduct'

export interface TitleOverlayProps {
    videoDetails: VideoDetails
    videoDuration?: string
    autoplayRemainingTime?: number
    compactMode: boolean

    play: () => void
    cancelAutoplay: () => void
}

export const TitleOverlay: React.FC<TitleOverlayProps> = ({
    videoDuration,
    videoDetails,
    play,
    autoplayRemainingTime,
    cancelAutoplay,
    compactMode,
}) => {
    const isCountingDown = autoplayRemainingTime !== undefined
    const product = useProduct()

    return (
        <ThemedRender
            sevennews={() => (
                <StyledTitleOverlay compactMode={compactMode}>
                    <PlayButton
                        onClick={play}
                        isSmallIcon={true}
                        isCentered={false}
                        isInversed={product !== Product.SevenNews}
                    />
                    <StyledInset>
                        <StyledTitles>
                            {!compactMode && (
                                <StyledVideoMetadata
                                    duration={videoDuration}
                                    source={videoDetails.source}
                                />
                            )}
                            <StyledHeading
                                title={videoDetails.heading}
                                autoPlayIsEnabled={isCountingDown}
                            >
                                {videoDetails.heading}
                            </StyledHeading>
                        </StyledTitles>
                        {isCountingDown && (
                            <StyledAutoplayWrap>
                                <StyledCountdown>
                                    Video will play in{' '}
                                    <StyledCountdownTime>
                                        {autoplayRemainingTime}
                                    </StyledCountdownTime>
                                    ..
                                </StyledCountdown>
                                <StyledCancel
                                    className="video-js__autoplay-control"
                                    type="button"
                                    onClick={cancelAutoplay}
                                >
                                    Don't play video
                                </StyledCancel>
                            </StyledAutoplayWrap>
                        )}
                    </StyledInset>
                </StyledTitleOverlay>
            )}
            fallback={() => (
                <StyledTitleOverlay compactMode={compactMode}>
                    <PlayButton
                        onClick={play}
                        isCentered={false}
                        isInversed={product !== Product.SevenNews}
                    />
                    <StyledInset>
                        <StyledTitles>
                            <StyledHeading
                                title={videoDetails.heading}
                                autoPlayIsEnabled={isCountingDown}
                            >
                                {videoDetails.heading}
                            </StyledHeading>
                            {!compactMode && (
                                <StyledVideoMetadata
                                    duration={videoDuration}
                                    source={videoDetails.source}
                                />
                            )}
                        </StyledTitles>
                        {isCountingDown && (
                            <StyledAutoplayWrap>
                                <StyledCountdown>
                                    Video will play in{' '}
                                    <StyledCountdownTime>
                                        {autoplayRemainingTime}
                                    </StyledCountdownTime>
                                </StyledCountdown>
                                <StyledCancel
                                    className="video-js__autoplay-control"
                                    type="button"
                                    onClick={cancelAutoplay}
                                >
                                    Stop Autoplay
                                </StyledCancel>
                            </StyledAutoplayWrap>
                        )}
                    </StyledInset>
                </StyledTitleOverlay>
            )}
        />
    )
}
TitleOverlay.displayName = 'TitleOverlay'
